import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lBmtU"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("aPVyw"), parcelRequire.load("8Jf43"), parcelRequire.load("5vIhg"), parcelRequire.load("daKqH"), parcelRequire.load("jkk6G"), parcelRequire.load("lfyA4"), parcelRequire.load("7OrX7"), parcelRequire.load("6vxyL"), parcelRequire.load("6n0X0")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("aPVyw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("8Jf43")} />
  <link rel="modulepreload" href={parcelRequire.resolve("5vIhg")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lBmtU")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("daKqH")} />
  <link rel="modulepreload" href={parcelRequire.resolve("jkk6G")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lfyA4")} />
  <link rel="modulepreload" href={parcelRequire.resolve("7OrX7")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6vxyL")} />
  <link rel="modulepreload" href={parcelRequire.resolve("6n0X0")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
